import React, { useEffect } from 'react'
import { View, Text, TextInput } from 'react-native'
import { useValuesDeclareFailure } from '../../hooks/useValuesDeclareFailure'
import { formStyles } from './styles'
import { handleFormatValue } from '../../helpers'
import { inputStyle } from '../../../../theme/inputs'
import { FailureValues } from '../../../../types'
import { useTranslation } from 'react-i18next'

interface Values {
  ship: string
}

interface Props {
  getValues: (values: FailureValues) => void
  initialValues?: FailureValues
}
export const CategoryTwoFailureForm = ({ getValues, initialValues }: Props) => {
  const { t } = useTranslation()
  const { handleAddSymbol, handleChange, values } = useValuesDeclareFailure<Values>({
    ship: initialValues?.ship ? `${initialValues?.ship}` : '',
  })

  useEffect(() => {
    getValues({
      diver: null,
      noRelief: null,
      hydraulic: null,
      work: null,
      dotation: null,
      ship: handleFormatValue(values.ship),
    })
  }, [values])

  return (
    <View style={formStyles.container}>
      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('BARCO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'ship')}
          onEndEditing={(val) => handleAddSymbol(val.nativeEvent.text, 'ship')}
          value={values.ship}
          style={[inputStyle.basicInput]}
          placeholder={t('Ingresar % de Falla')}
        />
      </View>
    </View>
  )
}
